{
  "modes": {
    "descent":   { "distanceScore": false, "bigfoot": true,  "gates": 0,  "gateMissPenaltyS": 5, "pickups": false, "severeCrashEnds": false, "difficultyScale": {} },
    "freeride":  { "distanceScore": true,  "bigfoot": true,  "gates": 0,  "gateMissPenaltyS": 5, "pickups": true,  "severeCrashEnds": false, "difficultyScale": {} },
    "timeTrial": { "distanceScore": false, "bigfoot": false, "gates": 20, "gateMissPenaltyS": 5, "pickups": false, "severeCrashEnds": false, "difficultyScale": { "dogDensity": 0, "gateFrequency": 1 } },
    "jumpPark":  { "distanceScore": false, "bigfoot": false, "gates": 0,  "gateMissPenaltyS": 5, "pickups": true,  "severeCrashEnds": false, "difficultyScale": { "jumpFrequency": 3, "treeDensity": 0.3 } }
  },
  "severeCrash": { "count": 3, "windowS": 10 }
}
